import { Box, Container } from '@mui/material';
import PageHeader from 'components/common/PageHeader/PageHeader';
import StoresTable from 'components/tables/StoresTable/StoresTable';
import useGlobalStyles from 'styles/globalStyles';


export default function AllStoresPage() {
  const globalStyles = useGlobalStyles();

  return (
    <Box className={globalStyles.container}>
      <Container
        maxWidth={'xl'}
        className={globalStyles.container}
      >
        <Box pt={2}>
          <PageHeader
            title={'All Stores'}
            buttons={[]}
          />
        </Box>

        <Box mt={3}>
          <StoresTable />
        </Box>
      </Container>
    </Box>
  )
}
